import {ApiHelper, axiosInstance } from '../../utils/ApiHelper'
import { dateRangeToStrings, toSlider, toAMPM, sliderToTime, formatHourRange } from './reducer'


const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const waitForPremiumUnlock = (values, dispatch ) => {
  return sleep(0).then(() => {
    // simulate server
    console.log('promise fired')
    // NOTE what about rejections or errors being handled by ant message?
      // throw { username: 'That username is taken' }
      dispatch(showPremiumModal())
      // TODO
      // throw new SubmissionError({
      //        username: 'User does not exist',
      //        _error: 'Login failed!'
      //      })

      console.log('Work hours are only for premium users')


      // throw new Error('Work hours are only for premium users')

  })
}

export function save(values) {
  return (dispatch, getState) => {
    dispatch({type:"REQUEST_UPDATE_WORK_HOURS"})

    // TODO check if premium from user?
    const { isPremium } = getState().models.user
    // TODO in reducer, set prevState
    if (!isPremium) {
      return waitForPremiumUnlock(values, dispatch)
      // dispatch(showPremiumModal())
      // TODO show spinner
      // on success, send values
      // on reject, reset values
    }


    const data = {
      "work_hours": {
        ...values,
        ...dateRangeToStrings(values)
      }
    }

    return ApiHelper.updateUser(data)
    .then((response)=>{
      dispatch({type:'UPDATE_WORK_HOURS', user: response.data})
    })

  }
}


export function toggleDay(day) {
  return {type:"TOGGLE_DAY", day}
}


function showPremiumModal() {
  return {
    type: 'SHOW_MODAL',
    modalType: 'UNLOCK_PREMIUM_MODAL',
    modalProps: {

    }
  }
}



// WEBPACK FOOTER //
// ./src/account/work-hours/actions.js